import { useEffect, useState } from 'react'
import useBoundDashboardStore from '../store/dashboardGlobalStore';
import { ICourierSnap, IDeliveryStatus, IOrder, IRoute, IServerTime } from '../models/model-interface';
import { ACTIVE_COURIER_SORT_BY_ORDER } from '../models/model-constants';
import { shallow } from 'zustand/shallow'

export const useDashboardStore = () => {
  const [courierStatus, setCourierStatus] = useState<IDeliveryStatus[]>();
  const [activeCouriers, setActiveCouriers] = useState<ICourierSnap[]>();
  const [couriersList, setCouriersList] = useState<ICourierSnap[]>();
  const [pendingCouriers, setPendingCouriers] = useState<ICourierSnap[]>();
  const [orderList, setOrderList] = useState<IOrder[]>();
  const [courierRoute, setCourierRoute] = useState<IRoute[]>();
  const [courierNextRoute, setCourierNextRoute] = useState<IRoute[]>();
  const [serverTime, setServerTime] = useState<IServerTime>();

  const [hasCourier, setHasCourier] = useState<boolean | null>(null);
  useEffect(() => {

    const unsubscribe = useBoundDashboardStore.subscribe(
      (state) => [
        state.couriers,
        state.orders,
        state.routes,
        state.getDeliveryStatusById(),
        state.deliveryStatuses,
        state.isCourierEmpty(),
        state.nextRoutes,
        state.getServerTime()
      ],
      ([couriers, orders, routes, statusIdMap, deliveryStatus, isCourierEmpty, nextRoutes, serverTimeStore]) => {
        const activeStatuses = statusIdMap;
        const sortByStatuses = deliveryStatus;
        const stateActiveCouriers = couriers
          .filter((c: ICourierSnap) => activeStatuses.includes(c.id))
          .sort(
            (a: ICourierSnap, b: ICourierSnap) =>
              ACTIVE_COURIER_SORT_BY_ORDER[
              sortByStatuses.find((s: IDeliveryStatus) => s.courierId == a.id)
                .currentDeliveryStatus
              ] -
              ACTIVE_COURIER_SORT_BY_ORDER[
              sortByStatuses.find((s: IDeliveryStatus) => s.courierId == b.id)
                .currentDeliveryStatus
              ]
          );
        const statePendingCouriers = couriers.filter(
          (c: ICourierSnap) => !activeStatuses.includes(c.id)
        );
        setCourierStatus(deliveryStatus);
        setActiveCouriers(stateActiveCouriers);
        setPendingCouriers(statePendingCouriers);
        setOrderList(orders);
        setCourierRoute(routes);
        setCouriersList(couriers);
        setHasCourier(isCourierEmpty);
        setCourierNextRoute(nextRoutes)
        setServerTime(serverTimeStore)
      },
      { fireImmediately: true, equalityFn: shallow }
    );

    return unsubscribe;
  }, []);

  return {
    courierStatus,
    activeCouriers,
    pendingCouriers,
    orderList,
    courierRoute,
    couriersList,
    hasCourier,
    courierNextRoute,
    serverTime,
  }
}


export default useDashboardStore